import React from 'react';
import PropTypes from 'prop-types';

import './pager-link.scss';
import { IClassNames, makeClassNames } from '../../../utils/styles';

const classNames = (isCurrentPage: boolean | undefined): IClassNames =>
  makeClassNames({
    pagerLink: ['pager-link', isCurrentPage && 'pager-link--active'],
  });

export interface IPagerLink {
  label: React.ReactNode;
  id: number | string;
  onClickCallback?: (x: number | string) => any;
  link?: string;
  isCurrentPage?: boolean;
}

const PagerLink: React.FC<IPagerLink> = ({ isCurrentPage, label, link, id, onClickCallback }) => {
  const cn = classNames(isCurrentPage);

  return !onClickCallback ? (
    <a href={link} className={cn.pagerLink}>
      {label}
    </a>
  ) : (
    <a onClick={() => onClickCallback(id)} className={cn.pagerLink}>
      {label}
    </a>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  PagerLink.propTypes = {
    id: PropTypes.number.isRequired,
    isCurrentPage: PropTypes.bool,
    label: PropTypes.node.isRequired,
    link: PropTypes.string,
    onClickCallback: PropTypes.func,
  };
}

export default PagerLink;
